<template>
	<article class="splash-manage-page">
		<form @submit.prevent="searching">
			<managing-section>
				<managing-box title="스플래시명">
					<input type="text" v-model="title" />
				</managing-box>
				<managing-box title="노출기간">
					<DateRange v-model="reservedPeriod" type="date" />
				</managing-box>
				<managing-box title="상태">
					<RadioList
						v-model="splashDisplayStatus"
						:radio-list="splashDisplayStatusList"
					/>
				</managing-box>
			</managing-section>

			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'다시작성'"
					@click="rewriting"
				/>
			</div>
		</form>

		<hr class="section__divider" />

		<managing-section :is-table="true">
			<!-- <template slot="infoSection">
                <div class="section__info__left">
                    <template v-if="currStatus === 0">
                        <span class="bold-text">검색결과 :  전체 {{ totalItem }}건</span> (노출 {{ displayTotal }}건 / 미노출 {{ noDisplayTotal }}건)
                    </template>
                    <template v-else-if="currStatus === 1">
                        <span class="bold-text">검색결과 :  노출 {{ displayTotal }}건</span>
                    </template>
                    <template v-else-if="currStatus === 2">
                        <span class="bold-text">검색결과 :  미노출 {{ noDisplayTotal }}건</span>
                    </template>
                </div>
            </template> -->
			<table class="table-main splash-manage__table">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록시간</th>
						<th>스플래시명</th>
						<th>Android 세트 1</th>
						<th>Android 세트 2</th>
						<th>Android 세트 3</th>
						<th>iOS 세트 1</th>
						<th>시작일시</th>
						<th>종료일시</th>
						<th>상태</th>
						<th>관리자명</th>
						<th>시작팝업</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr
						:class="{
							'splash-manage__table__display-row':
								item.status === '노출',
						}"
						v-for="item in list"
						:key="item.id"
					>
						<td>{{ item.id }}</td>
						<td v-html="item.submitTime"></td>
						<td class="splash-manage__table__td-title">
							<router-link
								class="link splash-manage__link"
								:to="item.link"
								>{{ item.title }}</router-link
							>
						</td>
						<td>{{ item.hasAosSet1 }}</td>
						<td>{{ item.hasAosSet2 }}</td>
						<td>{{ item.hasAosSet3 }}</td>
						<td>{{ item.hasIosSet1 }}</td>
						<td v-html="item.reservedFrom"></td>
						<td v-html="item.reservedTo"></td>
						<td>{{ item.status }}</td>
						<td>{{ item.nickName }}</td>
						<td>{{ item.isConnectPopup }}</td>
						<td>
							<button
								class="btn-delete"
								type="button"
								@click="deleting(item.id)"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				:total-item="totalItem"
				:limit="itemSize"
				:offset="Number(currentPage)"
				@to="paging"
				slot="pagination"
			/>
		</managing-section>
	</article>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import { stringify } from 'query-string';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';
	import PaginationBox from '@/components/PaginationBox.vue';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'SplashManage',
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			PaginationBox,
			RadioList,
		},
		data() {
			return {
				currStatus: 0,
				title: '',
				reservedPeriod: { from: '', to: '' },
				splashDisplayStatusList: [
					{ id: 0, value: '전체' },
					{ id: 2, value: '미노출' },
					{ id: 1, value: '노출' },
				],
				splashDisplayStatus: 0,
				totalItem: 0,
				itemSize: 50,
				currentPage: 0,
				list: [],
				displayTotal: 0,
				noDisplayTotal: 0,
			};
		},
		watch: {
			$route(to, from) {
				this.getQuery(this.$route.query);
			},
		},
		mounted() {
			this.getQuery(this.$route.query);
		},
		methods: {
			routerPush(args) {
				if (_.isEqual(args.query, this.$route.query)) return;
				const obj = JSON.parse(JSON.stringify(args));
				this.$router.push(obj);
			},
			paging(args) {
				const currentPage = args.offset;
				const currQuery = this.$route.query;
				this.routerPush({
					path: this.$route.path,
					query: Object.assign({}, currQuery, { currentPage }),
				});
			},
			hasImg(list, res) {
				return list.every(item => {
					return res.hasOwnProperty(item.id) && res[item.id];
				})
					? 'O'
					: 'X';
			},
			getDate(date) {
				return moment(date, 'YYYYMMDDHHmmSS').format(
					'YYYY-MM-DD<br>HH:mm:SS'
				);
			},
			getParams() {
				if (this.title.length === 1) {
					alert('검색어는 2글자 이상 입력해주세요.');
					return false;
				}
				const { from, to } = this.reservedPeriod;
				return {
					title: this.title,
					currentPage:
						this.currentPage === 0
							? 1
							: Math.floor(this.currentPage / this.itemSize) + 1,
					itemSize: this.itemSize,
					splashDisplayStatus: this.splashDisplayStatus,
					reservedFrom: from
						? moment(from, 'YYYY-MM-DD').format('YYYYMMDDHHmmss')
						: null,
					reservedTo: to
						? moment(to, 'YYYY-MM-DD')
								.endOf('date')
								.format('YYYYMMDDHHmmss')
						: null,
				};
			},
			parseList(list) {
				if (!list || list.length < 1) return [];
				const state = this.$store.state.splash;
				return list.map(item => {
					item = { ...item, ...JSON.parse(item.doc) };
					delete item.doc;

					return {
						id: item.id,
						submitTime: this.getDate(item.submitTime),
						title: item.title,
						link: `${this.$store.state.paths.SplashModify}/${item.id}`,
						hasAosSet1: item.aos10802640 ? 'O' : 'X',
						hasAosSet2: item.aos14403000 ? 'O' : 'X',
						hasAosSet3: item.aos14403200 ? 'O' : 'X',
						hasIosSet1: this.hasImg(state.iosList[0], item),
						reservedFrom: item.isReserved
							? this.getDate(item.reservedFrom)
							: '상시노출',
						reservedTo: item.isReserved
							? this.getDate(item.reservedTo)
							: '상시노출',
						status: item.status === 1 ? '노출' : '미노출',
						nickName: item.nickName,
						isConnectPopup:
							item.isConnectPopup === 1 ? '연결' : '미연결',
					};
				});
			},
			async getList() {
				try {
					const params = this.getParams();
					if (!params) return;
					const { data } = await this.$axiosAdmin2.get(
						`/api/splash/list?${stringify(params)}`
					);
					this.list = this.parseList(data.result.resultList);
					this.currStatus = Number(params.splashDisplayStatus);
					this.totalItem = data.result.totalCount || 0;
					this.displayTotal = data.splashStatistics.displayTotal || 0;
					this.noDisplayTotal =
						data.splashStatistics.noDisplayTotal || 0;
				} catch (err) {
					console.error(err);
					alert(
						'스플래시 리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getQuery(query) {
				this.title = query.title || '';
				this.reservedPeriod = {
					from: query.reservedFrom || '',
					to: query.reservedTo || '',
				};
				this.splashDisplayStatus =
					Number(query.splashDisplayStatus) || 0;
				this.currentPage = Number(query.currentPage) || 0;
				this.getList();
			},
			searching() {
				this.currentPage = 0;
				const query = {
					title: this.title,
					splashDisplayStatus: this.splashDisplayStatus,
					currentPage: this.currentPage,
				};
				const { from, to } = this.reservedPeriod;
				if (from) {
					query.reservedFrom = from;
				}
				if (to) {
					query.reservedTo = to;
				}
				this.routerPush({
					path: this.$route.path,
					query,
				});
			},
			rewriting() {
				this.title = '';
				this.reservedPeriod = { from: '', to: '' };
				this.splashDisplayStatus = 0;
				if (_.isEmpty(this.$route.query)) {
					return;
				}
				this.routerPush({
					path: this.$route.path,
					query: null,
				});
			},
			async deleting(id) {
				try {
					if (!confirm('스플래시 이미지를 삭제하시겠습니까?')) return;
					this.$store.commit('toggleSpinner', true);
					const res = await this.$axiosAdmin2.delete(
						`/api/splash/${id}`
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'스플래시 이미지를 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.bold-text {
		font-weight: 700 !important;
	}

	.splash-manage-page .splash-manage__table {
		th,
		td {
			white-space: nowrap;
		}

		.splash-manage__table__td-title {
			width: 100%;
		}
	}

	.splash-manage__link {
		white-space: normal;
		word-wrap: break-word;
		word-break: break-all;
		font-weight: bold;

		&:after {
			content: '';
			display: block;
			width: 215px;
		}
	}

	.splash-manage__table__display-row {
		background: rgba(6, 108, 223, 0.4);
	}
</style>
